import { motion, AnimatePresence } from "framer-motion"

import { useMemo, useEffect, useRef } from 'react'

import useAuthStore from "../../store/useAuthStore";
import useLayoutStore from "../../store/useLayoutStore";
import useAppStore from "../../store/useAppStore";

const ProfileModal = ({ onClose }) => {

    const logout = useAuthStore.getState().logout
    const isDarkTheme = useLayoutStore(state => state.isDarkTheme)
    const userId = useAuthStore(state => state.userId)
    const userData = useAppStore(state => state.employeesData?.[userId])
    const modalContainerRef = useRef(null)

    const modalData = useMemo(() => {
        if (!userData) {
            return {
                imgUrl: null,
                firstName: '',
                lastName: '',
                email: '',
                presenceType: 'Offline',
                buttonText: 'Prijava na posao',
                buttonIcon: './../sidebar/darkTheme.svg',
            }
        }

        const baseImgUrl = import.meta.env.VITE_API_IMAGES_URL;
        const imgUrl = userData.image ? `${baseImgUrl}/employees/${userData.image}` : null

        let presenceType = 'Offline';
        let buttonText = 'Prijava na posao';
        let buttonIcon = './../sidebar/darkTheme.svg';

        if (userData.aktivan_status === 'ulaz') {
            buttonText = 'Odjava sa posla'
            if (userData.presenceType === 'remote') {
                presenceType = 'Rad od kuće'
                buttonIcon = './../sidebar/Office.svg'
            } else {
                presenceType = 'Rad iz kancelarije'
                buttonIcon = './../sidebar/Ekran.svg'
            }
        }

        return {
            imgUrl,
            firstName: userData.ime,
            lastName: userData.prezime,
            email: userData.username,
            presenceType,
            buttonText,
            buttonIcon,
        }
    }, [userData])

    useEffect(() => {
        const handleClickOutside = (e) => {
            // Ako je klik na modal container, ne zatvaraj modal
            if (modalContainerRef.current && modalContainerRef.current.contains(e.target)) {
                return;
            }

            // // Ako je klik na dugme koje otvara modal, ne zatvaraj modal
            const profileButton = e.target.closest('.profile-button');
            if (profileButton) {
                return;
            }

            onClose();
        };

        document.addEventListener('mousedown', handleClickOutside, true);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside, true);
        };
    }, [onClose]);

    return (
        <>
            <motion.div
                ref={modalContainerRef}
                className={`profile-modal-container ${isDarkTheme ? "dark-profile-modal" : "white-profile-modal"}`}
                initial={{ opacity: 0, x: -14 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -14 }}
                transition={{ duration: 0.19, ease: "easeInOut" }}
                onClick={(e) => e.stopPropagation()}
            >
                <button
                    className={`profile-modal-close-button ${isDarkTheme ? "filter-dark-buttons" : ""}`}
                    onClick={onClose}
                    aria-label="Close modal"
                >
                    <svg
                        width="28"
                        height="28"
                        viewBox="0 0 28 28"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ display: "block", margin: "auto" }}
                    >
                        <line x1="7.2" y1="7.2" x2="20.8" y2="20.8" stroke="#08293e" strokeWidth="2.4" strokeLinecap="round" />
                        <line x1="20.8" y1="7.2" x2="7.2" y2="20.8" stroke="#08293e" strokeWidth="2.4" strokeLinecap="round" />
                    </svg>
                </button>
                <ToggleThemeButton />
                <div className="profile-modal-content">
                    <div className="pmc-name-container">
                        {modalData.firstName} {modalData.lastName}
                    </div>
                    <div className="pmc-email-container">
                        {modalData.email}
                    </div>
                    <div className="pmc-presence-type-container">
                        <img src={modalData.buttonIcon} alt="" />
                        {modalData.presenceType}
                    </div>
                    {/* <button className="pmc-button pmc-settings-button">
                        <img src="./sidebar/Podesavanja.svg" alt="" />
                        <span>Podešavanja naloga</span>
                    </button> */}
                    <button className="pmc-button pmc-logout-button" onClick={logout}>
                        <img src="./login/Back.svg" alt="" />
                        <span>Odjava se portala</span>
                    </button>
                    <button
                        className="pmc-button pmc-presence-button"
                        onClick={() => {
                            onClose();
                            useAppStore.getState().setIsWorkPresenceFormOpen(true);
                        }}
                    >
                        <img src="./login/ExitDoor.svg" alt="" />
                        <span>{modalData.buttonText}</span>
                    </button>
                </div>
                <div className="profile-modal-img-container">
                    <img
                        key={modalData.imgUrl || "profile-fallback"}
                        src={modalData.imgUrl || "/views/login.svg"}
                        alt="profile"
                        crossOrigin="use-credentials"
                        className={isDarkTheme ? "dark-profile-modal-img" : "white-profile-modal-img"}
                        onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = "/views/login.svg";
                        }}
                    />
                </div>

            </motion.div>
            <motion.div
                className={`profile-modal-bg-wrapper ${isDarkTheme ? "dark-profile-modal-bg-wrapper" : "white-profile-modal-bg-wrapper"}`}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 1 }}
                transition={{ duration: 0.14, ease: "easeInOut" }}
                style={{ pointerEvents: 'none' }}
            >

            </motion.div>
        </>
    )
}

// const ProfileModal = ({ onClose }) => {
//     const logout = useAuthStore.getState().logout
//     return (
//         <motion.div
//             className="profile-modal-container"
//             onClick={onClose}
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             exit={{ opacity: 0, delay: 0.14 }}
//             transition={{ duration: 0.14, ease: "easeInOut" }}
//         >
//             <motion.div
//                 className="profile-modal"
//                 initial={{ opacity: 0, scale: 0.4 }}
//                 animate={{ opacity: 1, scale: 1 }}
//                 exit={{ opacity: 0, scale: 0.4 }}
//                 transition={{ duration: 0.14, ease: "easeInOut" }}
//                 onClick={(e) => e.stopPropagation()}
//             >
//                 <StartEndShiftButton />
//                 <button
//                     onClick={logout}
//                     style={{
//                         marginTop: "10px",
//                         backgroundColor: "#424242",
//                         color: "white",
//                         border: "none",
//                         padding: "10px 20px",
//                         borderRadius: "8px",
//                         cursor: "pointer",
//                         fontWeight: 600,
//                         fontSize: "15px",
//                     }}
//                 >
//                     Logout
//                 </button>
//             </motion.div>
//         </motion.div>
//     )
// }

export default ProfileModal

const ToggleThemeButton = () => {
    const isDarkTheme = useLayoutStore(state => state.isDarkTheme)
    const toggleTheme = useLayoutStore(state => state.toggleTheme)

    return (
        <button
            className={`theme-button ${isDarkTheme ? "filter-dark-buttons" : ""}`}
            onClick={(e) => {
                e.stopPropagation();
                toggleTheme();
            }}
        >
            <AnimatePresence mode="wait">
                <motion.img
                    key={isDarkTheme ? "light" : "dark"}
                    src={isDarkTheme ? "./sidebar/lightTheme.svg" : "./sidebar/darkTheme.svg"}
                    alt="Toggle Theme"
                    initial={{ scale: 0 }}
                    animate={{ scale: isDarkTheme ? 1 : 0.9 }}
                    exit={{ scale: 0 }}
                    transition={{ duration: 0.19, ease: "easeInOut" }}
                />
            </AnimatePresence>
        </button>
    )
}
